import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from 'app/security/auth.service';
import { ClientService } from 'app/services/client-service';
@Component({
    selector: 'app-profile-contact',
    templateUrl: './profile-contact.component.html',
    styleUrls: ['./profile-contact.component.scss']
})
export class ProfileContactComponent {

    @Input() profileData: any;

    isCompany: boolean = true;

    // El banner de "perfil completo" solo se muestra cuando el perfil está al 100%.
    show: Boolean = false;

    @Output() profileAction = new EventEmitter<{ section: string }>();

    constructor(private authService: AuthService, private clientService: ClientService) { }
    ngOnInit() {
        if ((this.authService.isLogged())) {
            const user = this.authService.getUser();
            user.documentType && user.documentType == 'CIF' ? this.isCompany = true : this.isCompany = false;
        }

        this.clientService.observerClientPercentageObserved().subscribe((result: any) => {
            this.show = (result === 100);
        });
    }

    get phone(): String {
        let phonePrefix = '';
        let phone = ''
        if (this.profileData) {
            if (this.profileData.phonePrefix) {
                phonePrefix = '+' + this.profileData.phonePrefix + ' ';
            }
            if (this.profileData.phone) {
                phone = this.profileData.phone;
            }
        }
        if (phone !== '' && phone !== null && phone !== 'null') {
            return phonePrefix + phone;
        } else {
            return '';
        }
    }

    get mobilePhone(): String {
        let phonePrefix = '';
        let phone = ''
        if (this.profileData) {
            if (this.profileData.mobilePhonePrefix) {
                phonePrefix = '+' + this.profileData.mobilePhonePrefix + ' ';
            }
            if (this.profileData.mobilePhone) {
                phone = this.profileData.mobilePhone;
            }
        }
        if (phone !== '' && phone !== null && phone !== 'null') {
            return phonePrefix + phone;
        } else {
            return '';
        }
    }

    get poblacion(): string {
        if (!this.profileData) { return ''; }
        const cp = this.profileData.zip || this.profileData.postalCode || '';
        const city = this.profileData.cityDescription || '';
        const prov = this.profileData.province || '';
        return [cp, [city, prov].filter(Boolean).join(', ')].filter(Boolean).join(' ');
    }

    // Fecha de nacimiento con guiones (dd-mm-aaaa), como el resto de la app.
    get birthDateFormatted(): string {
        return (this.profileData && this.profileData.birthDate)
            ? this.profileData.birthDate.replace(/\//g, '-')
            : '';
    }

    onEditClick(): void {
        this.profileAction.emit({ section: 'profile-modification'});
    }
}
